<master-detail-editor [display]="display">

  <ng-container *masterDetailEditorLeftActions>
    <w-button [command]="toggleAddToDownloadsCommand" size="Medium" buttonClass="toggle-add-to-list"></w-button>
    @if (!!editCommand) {
      <w-button [command]="editCommand" size="Medium" buttonClass="toggle-add-to-list"></w-button>
    }
  </ng-container>


  <ng-template masterDetailEditorRightActions>

    <a (click)="movePrev()" title="Move to previous task" [ngClass]="{disabled: !canMovePrev}">
      <i class="fa-regular fa-chevron-up"></i>
    </a>
    <a (click)="moveNext()" title="Move to next task" [ngClass]="{disabled: !canMoveNext}">
      <i class="fa-regular fa-chevron-down"></i>
    </a>
    <!-- <a (click)="onPreview()" title="Expand" *ngIf="canExpand">
    <i class="fa-regular" [ngClass]="{'fa-arrow-up-right-and-arrow-down-left-from-center': display === MasterDetailEditorDisplayMode.Default || display === MasterDetailEditorDisplayMode.Modal, 'fa-arrow-down-left-and-arrow-up-right-to-center': display === MasterDetailEditorDisplayMode.Expanded}"></i>
  </a> -->
    @if (display !== MasterDetailEditorDisplayMode.Expanded) {
      <a (click)="dismiss()" title="Close">
        <i class="fa-regular" [ngClass]="{'fa-right-to-line': display === MasterDetailEditorDisplayMode.Default, 'fa-xmark': display !== MasterDetailEditorDisplayMode.Default}"></i>
      </a>
    }

  </ng-template>


  <div class="fieldset" *masterDetailEditorBody>

    <attachment (itemClicked)="onPreview()" [attachment]="attachment" [enableVideoPlayer]="attachment.type === 'Video'" [registerWithKeyManager]="false" [thumbnailHeight]="280" [showMetadata]="false" [showTags]="false" [selectable]="false" [deletable]="$isEditableActivityFile()" (delete)="delete.emit($event)" />

    <legend>Details</legend>

    @if (attachment?.title) {
      <div class="field">
        <label>Name</label>
        <div class="value">{{attachment?.title}}</div>
      </div>
    }

    @if (attachment?.createdDate) {
      <div class="field">
        <label>Created Date</label>
        <div class="value">{{$safeNavigationMigration(attachment?.createdDate) | dateTimeFormat:$safeNavigationMigration(context?.timezone):'dd/MM/yyyy hh:mm a' }}</div>
      </div>
    }

    @for (tag of attachment?.metadata; track tag) {
      @if (tag?.data) {
        <div class="field">
          <label>{{tag.name}}</label>
          <div class="value">{{tag.data}}</div>
        </div>
      }
    }

    @if ($isEditableActivityFile()) {

      @if (!context?.disableSharing) {

        @let instances = attachment?.effectiveSharing?.referenceInstances ?? 0;
      <!-- {} -->

        <div class="field">
          <label>File Sharing</label>
          <div class="value">
            <sharing-pro [formControl]="sharing" />
          </div>

        </div>

        @if(instances > 1) {

          <div class="field">
            <div class="value">
              <w-alert severity="info" [closable]="false" [showIcon]="false" [detail]="`There are ${instances - 1} references to this file. This may affect sharing.`" />
            </div>
          </div>

          <div class="field">
            <label>Effective Sharing</label>
            <div class="value">
              <sharing-pro displayStyle="Tertiary" [value]="$safeNavigationMigration(attachment?.effectiveSharing)" [readonly]="true" />
            </div>
          </div>

        }

      }

      <div class="field">
        <label>Tags</label>
        <div class="value">
          <w-select [readonly]="context.readonly" [items]="$tags.value()" [multiple]="true" [formControl]="tags" [closeOnSelect]="false" dropdownPosition="top" bindLabel="name" bindColor="color" />
        </div>
      </div>



    }

  </div>

  <ng-template masterDetailEditorFooter>
    @if(!context.readonly){
      <w-button label="Save" [disabled]="disableSubmit" displayStyle="Primary" size="Medium" (onClick)="onSave()"></w-button>
    }
  </ng-template>

</master-detail-editor>